module.exports = __webpack_public_path__ + "assets/img/s3_chart-1.14065394.png";